import { render, staticRenderFns } from "./AppointmentSettings.vue?vue&type=template&id=50cf831f"
import script from "./AppointmentSettings.vue?vue&type=script&lang=js"
export * from "./AppointmentSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports